import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { GoodsPhoto } from '../../../js/ComponentManager'

import { Swiper, SwiperSlide } from "swiper/react";
import {Thumbs } from 'swiper';
import "swiper/css";
import 'swiper/css/thumbs';

/* 개발담당:양유빈
 * 화면기능:상품리스트에서 상품을 클릭 하고 상품상세 조회
 * 세부설명:
*/

export class GoodsPre extends Component {
    static displayName = GoodsPre.name;

    constructor(props) {
        super(props);
        this.state = {
            FirstImage: "",
            ImageNumber: 1
        };
        this.handelPhoto_Click = this.handelPhoto_Click.bind(this);
        this.handelBack_Click = this.handelBack_Click.bind(this);
       
    }
    //초기화
   async componentDidMount() {
        
        if (this.props.ContentState !== null && this.props.ContentState.GoodsMgtModel.Goods_No !== null) {
            this.CallGoodsData();
        }
        else {
            
            let StringJson = JSON.stringify(this.props.ContentState);
            let JsonObj = JSON.parse(StringJson, function (prop, value) {
                var lower = prop.toLowerCase();
                if (prop === lower) return value;
                else this[lower] = value;
            });
            this.GoodsDataSetProp.GoodsMgtModel.push(JsonObj.goodsmgtmodel);
            this.GoodsDataSetProp.CategoryModel.push(JsonObj.categorymodel);
            this.GoodsDataSetProp.GoodsCrdModel = JsonObj.goodscrdmodel; 
            this.GoodsDataSetProp.GoodsMatalModel = JsonObj.goodsmatalmodel; 
            this.GoodsDataSetProp.GoodsMatchaModel = JsonObj.goodsmatchamodel; 
            this.GoodsDataSetProp.GoodsSizModel = JsonObj.goodssizmodel;
            this.GoodsDataSetProp.GoodsImgMgtModel.push(JsonObj.goodsimgmgtmodel);

            //이미지
            if (JsonObj.goodsimgmgtmodel.file_grp !== "") {
                await this.CallPhotoData(JsonObj.goodsimgmgtmodel.file_grp);
                
            }
            //제조국, 낱장여부
            if (JsonObj.goodsmgtmodel.made_by !== "" || JsonObj.goodsmgtmodel.sinsale_yn !== "") {
                await this.CallBaseData(JsonObj.goodsmgtmodel, JsonObj.goodsladrymodel);
                this.GoodsDataSetProp.GoodsLadryModel = JsonObj.goodsladrymodel; 
            }
            
            this.forceUpdate();  
       }
      
    }
    GoodsDataSetProp = {
        CategoryModel: [],
        GoodsCrdModel: [],
        GoodsImgMgtModel: [],
        GoodsLadryModel: [],
        GoodsMatalModel: [],
        GoodsMatchaModel: [],
        GoodsMatchaBaseModel: [],
        GoodsMgtModel: [],
        GoodsSizModel: [],
        GoodsPhotoModel: []
    }
    //사진클릭
    handelPhoto_Click(event, Rownum, ImagePath) {
        this.setState({ FirstImage: ImagePath, ImageNumber: Rownum });
        event.preventDefault();
    }
    //뒤로가기
    handelBack_Click = (event) => {
        this.props.RenderComponent("GoodsReg", this.props.ContentState);
        event.preventDefault();
    }
    //사진데이터 호출
    async CallPhotoData(File_Grp) {
        try {
            let Data = await Big3Common.Get(`api/Goods/GoodsReg/TempGoodsImage/${File_Grp}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                this.GoodsDataSetProp.GoodsPhotoModel = DataList;
            }
        }
        catch (e) {
            console.log("CallPhotoData: ", e)
        }
    }
    //미리보기 추가 정보 조회(제조국, 낱장여부, 세탁법)
    async CallBaseData(goodsmgtmodel, goodsladrymodel) {
        try {
            let made_by = goodsmgtmodel.made_by;
            let sinsale_yn = goodsmgtmodel.sinsale_yn;
            let Data = await Big3Common.Post(`api/Goods/GoodsReg/GetGoodsPreview`, { dtl_cd1: sinsale_yn, dtl_cd2: made_by }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataModelList = JSON.parse(Data.multiDataTable);
                let DataList = DataModelList.GoodsBaseModel;
                this.GoodsDataSetProp.GoodsMatchaBaseModel = DataModelList.GoodsMatchaBaseModel;
                if (DataList.length > 0) {
                    //낱장판매
                    goodsmgtmodel.sinsale_yn_nm = DataList.filter(list => list.mst_cd === '014' && list.dtl_cd === sinsale_yn)[0].dtl_nm;
                    //제조국
                    goodsmgtmodel.made_by_nm = DataList.filter(list => list.mst_cd === '003' && list.dtl_cd === made_by)[0].dtl_nm;
                    //###########세탁법
                    //기준정보 데이터
                    let ladryList = DataList.filter(list => list.mst_cd === '004');
                    //선택된 데이터
                    goodsladrymodel.map(list1 => {
                        let ladry_cd_nm = ladryList.filter(list2 => list1.ladry_cd === list2.dtl_cd)[0]["dtl_nm"];
                        list1.ladry_cd_nm = ladry_cd_nm;
                        return false;
                    });
                }
            }
        }
        catch (e) {
            console.log("CallBaseData: ", e)
        }
    }
    //조회 데이터 호출
    async CallGoodsData() {
        try {
            let Goods_No = this.props.ContentState.GoodsMgtModel.Goods_No;
            let Data = await Big3Common.Get(`api/Goods/GoodsMgr/GetGoodsDtl/${Goods_No}`, this.state, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                Object.assign(this.GoodsDataSetProp, DataList);
                this.forceUpdate();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsData: ", e)
        }
        return false;
    }
    //카테고리 바인딩
    Categoryrender() {
        let categorymodels = this.GoodsDataSetProp.CategoryModel;
        if (categorymodels.length > 0) {
            let categorymodel = categorymodels[0];
            return (
                <div className="pre_Category">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">{categorymodel.man_nm}</li>
                        <li className="breadcrumb-item">{categorymodel.mid_nm}</li>
                        <li className="breadcrumb-item">{categorymodel.sub_nm}</li>
                    </ol>
                </div>
            );
        }
        
    }
     
    //색상, 사이즈, 혼용률, 제조국, 낱장여부
    Product1render() {
        let GoodsCrdlist = this.GoodsDataSetProp.GoodsCrdModel;
        let ColorName = GoodsCrdlist.map(list => { return list.crd_nm }).toString().replaceAll(",", ", ");
        let GoodsSizlist = this.GoodsDataSetProp.GoodsSizModel;
        let SizeName = GoodsSizlist.map(list => { return list.siz_nm }).toString().replaceAll(",", ", ");
        let GoodsMatallist = this.GoodsDataSetProp.GoodsMatalModel;
        let MatalName = GoodsMatallist.map(list => { return `${list.matal_nm} ${list.ratio}% ` }).toString().replaceAll(",", ", ");
        let Made_Nm = "";
        let Sinsale_Nm = "";
        if (this.GoodsDataSetProp.GoodsMgtModel.length > 0) {
            Made_Nm = this.GoodsDataSetProp.GoodsMgtModel[0].made_by_nm;
            Sinsale_Nm = this.GoodsDataSetProp.GoodsMgtModel[0].sinsale_yn_nm;
        }
        let GoodsLadryList = this.GoodsDataSetProp.GoodsLadryModel;
        let GoodsLadryName = GoodsLadryList.map(list => { return list.ladry_cd_nm }).toString().replaceAll(",", ", ");
        
        return (
            <div className="protuct_intro">
                <div className="title">상품설명</div>
                <div className="product_info_line first_line">
                    <div className="product_info_title">색상</div>
                    <div className="product_info_cont">{ColorName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">사이즈</div>
                    <div className="product_info_cont">{SizeName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">혼용률</div>
                    <div className="product_info_cont">{MatalName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">제조국</div>
                    <div className="product_info_cont">{Made_Nm}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">낱장여부</div>
                    <div className="product_info_cont">{Sinsale_Nm}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">세탁법</div>
                    <div className="product_info_cont">{GoodsLadryName}</div>
                </div>
            </div>
        );
    }
    //상품소재 특성
    Product2render() {
        let GoodsMatchaModel = this.GoodsDataSetProp.GoodsMatchaModel;
        if (GoodsMatchaModel.length === 0) {
            return ("");
        }
        //소재정보 기준정보 값
        let GoodsMatchaBaseModel = Big3Common.Util.groupBy(this.GoodsDataSetProp.GoodsMatchaBaseModel, list => list.matgrp_nm);         
        //render에 바인됭 리스트
        let MatchaGrp = [];
        //소재정보 셋팅
        for (const item of GoodsMatchaBaseModel.entries()) {
            //소재정보 리스트 세부 항목           
            let itemList = item[1];
            //클릭한 소재정보 
            let SelectState = [];
            //소재정보에서 선택된 값이 있으면 설정
            itemList.forEach(function (items) {
                let EqualList = GoodsMatchaModel.filter(list => list.matcha_grp === items.matcha_grp && list.matcha_cd === items.matcha_cd);
                if (EqualList.length > 0) {

                    SelectState = EqualList;
                }
            });
            MatchaGrp.push({ "matgrp_nm": item[0], "Childlist": item[1], "SelectState": SelectState[0] });
        }

        return (
            <div className="protuct_intro">
                <div className="title">소재정보</div>
                {
                    MatchaGrp.map((list, idx) =>
                        <div className={idx === 0 ? "product_info_line first_line" : "product_info_line"} key={list.matgrp_nm}>
                            <div className="product_info_title">{list.matgrp_nm}</div>
                            {
                                list.Childlist.map(childs =>
                                    <div className="form-check product_info_check" key={childs.matcha_grp + '_' + childs.matcha_cd}>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            disabled
                                            style={{ opacity: "inherit" }}
                                            defaultChecked={childs.matcha_grp === list.SelectState.matcha_grp && childs.matcha_cd === list.SelectState.matcha_cd ? true : false}
                                            name={'matcha_' + childs.matcha_grp}
                                        />
                                        <label className="form-check-label" style={{ opacity: "inherit" }}>{childs.matcha_nm}</label>
                                    </div>
                                )}
                        </div>
                    )}
            </div>
        );

    }
    //상품사진
    PhotoListrender() {
        let GoodsPhotoList = this.GoodsDataSetProp.GoodsPhotoModel;
        if (GoodsPhotoList.length > 0) {
            let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
            let TotalCount = GoodsPhotoList.length;
            let LayoutWidth = Big3Common.Util.offsetWidth();
            let slidersCount = 13;
            slidersCount = Math.ceil(LayoutWidth / 100) - 1;
            if (slidersCount >= 13) {
                slidersCount = 13;
            }
            else if (slidersCount <= 5) {
                slidersCount = 5;
            }
            return (
                <div>
                    <Swiper
                        spaceBetween={10}
                        navigation={false}
                        className="mySwiper2"
                        modules={[Thumbs]}
                        thumbs={{ swiper: this.state.thumbsSwiper }}
                    >
                        <>
                            {
                                GoodsPhotoList.map((list,idx) =>
                                    <SwiperSlide key={list.rownum}
                                    >
                                            <GoodsPhoto
                                            className="pre_main_img"
                                            ImageSrc={list.img_1000}
                                            BackGround={false}
                                            TotalCount={<div className="photo_number">{idx + 1}/{TotalCount}</div>}
                                            />
                                    </SwiperSlide>
                                )}
                        </>
                    </Swiper>
                    <Swiper watchSlidesProgress={true}
                        slidesPerView={slidersCount}
                        className="mySwiper img_list_box"
                        modules={[Thumbs]}
                        onSwiper={(swiper) => this.setState({ thumbsSwiper: swiper })}
                    >
                        <div>
                            {
                                GoodsPhotoList.map(list =>
                                    <SwiperSlide key={list.rownum}
                                        className="img_list"
                                        style={{ width: "65px", height: "65px", backgroundImage: `url(${VirtualRoot}${list.img_100})` }}
                                    >
                                    </SwiperSlide>
                                )}
                            <SwiperSlide style={{ width: "65px", height: "65px" }}>
                                {/* 공백*/}
                            </SwiperSlide>
                        </div>
                    </Swiper>
                </div>
            )
        }
        else {
            return "";
        }

    }
    render() {
        let Category = this.Categoryrender();
        let Product1 = this.Product1render();
        let Product2 = this.Product2render();
        let GoodsMgtModel = this.GoodsDataSetProp.GoodsMgtModel;
        let PhotoList = this.PhotoListrender();
        let Goods_Nm = "";
        let Goods_Price = "0";
        let Dtl_Content = "";
        if (GoodsMgtModel.length > 0) {
            Goods_Nm = GoodsMgtModel[0].goods_nm;
            Goods_Price = GoodsMgtModel[0].goods_price;
            Dtl_Content = GoodsMgtModel[0].dtl_content;
        }
        return (
            <div className="pre_wrap">
                {PhotoList}
                <div className="pre_content_wrap">
                    {Category}
                    <div className="pre_title">{Goods_Nm}</div>
                    <div className="pre_price">{Big3Common.Util.Money(Goods_Price)}원</div>
                    <div className="protuct_intro">
                        <div className="title">제품설명</div>
                        <div className="product_txt">
                            {Dtl_Content}
                        </div>
                    </div>
                   
                    {Product1}
                    {Product2}
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={(e) => { this.handelBack_Click(e) }} style={{ cursor: 'pointer' }}>뒤로가기</button>
                </div> 
            </div>
        );
    }
}
